import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import AutoformPage from 'pages/AutoformPage';
import autoformPlaceholder from '../images/autoform-unselected.png';
import AutoformContainer from 'components/autoform/AutoformContainer';

export const autoformRoutes = {
    path: '/autoform/:autoformId',
    element: <AutoformPage />,
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />,
        },
        {
            path: ':itemId',
            element: <AutoformContainer />,
        },
    ],
};
